import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { SignatureV4 } from "@smithy/signature-v4";
import { SESSION_TOKEN_HEADER, SESSION_TOKEN_QUERY_PARAM } from "../constants";
export var SignatureV4S3Express = /*#__PURE__*/function (_SignatureV) {
  _inherits(SignatureV4S3Express, _SignatureV);
  var _super = _createSuper(SignatureV4S3Express);
  function SignatureV4S3Express() {
    _classCallCheck(this, SignatureV4S3Express);
    return _super.apply(this, arguments);
  }
  _createClass(SignatureV4S3Express, [{
    key: "signWithCredentials",
    value: function () {
      var _signWithCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(requestToSign, credentials, options) {
        var credentialsWithoutSessionToken, privateAccess;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                credentialsWithoutSessionToken = getCredentialsWithoutSessionToken(credentials);
                requestToSign.headers[SESSION_TOKEN_HEADER] = credentials.sessionToken;
                privateAccess = this;
                setSingleOverride(privateAccess, credentialsWithoutSessionToken);
                return _context.abrupt("return", privateAccess.signRequest(requestToSign, options !== null && options !== void 0 ? options : {}));
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function signWithCredentials(_x, _x2, _x3) {
        return _signWithCredentials.apply(this, arguments);
      }
      return signWithCredentials;
    }()
  }, {
    key: "presignWithCredentials",
    value: function () {
      var _presignWithCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(requestToSign, credentials, options) {
        var _requestToSign$query;
        var credentialsWithoutSessionToken, privateAccess;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                credentialsWithoutSessionToken = getCredentialsWithoutSessionToken(credentials);
                delete requestToSign.headers[SESSION_TOKEN_HEADER];
                requestToSign.headers[SESSION_TOKEN_QUERY_PARAM] = credentials.sessionToken;
                requestToSign.query = (_requestToSign$query = requestToSign.query) !== null && _requestToSign$query !== void 0 ? _requestToSign$query : {};
                requestToSign.query[SESSION_TOKEN_QUERY_PARAM] = credentials.sessionToken;
                privateAccess = this;
                setSingleOverride(privateAccess, credentialsWithoutSessionToken);
                return _context2.abrupt("return", this.presign(requestToSign, options));
              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function presignWithCredentials(_x4, _x5, _x6) {
        return _presignWithCredentials.apply(this, arguments);
      }
      return presignWithCredentials;
    }()
  }]);
  return SignatureV4S3Express;
}(SignatureV4);
function getCredentialsWithoutSessionToken(credentials) {
  var credentialsWithoutSessionToken = {
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey,
    expiration: credentials.expiration
  };
  return credentialsWithoutSessionToken;
}
function setSingleOverride(privateAccess, credentialsWithoutSessionToken) {
  var id = setTimeout(function () {
    throw new Error("SignatureV4S3Express credential override was created but not called.");
  }, 10);
  var currentCredentialProvider = privateAccess.credentialProvider;
  var overrideCredentialsProviderOnce = function overrideCredentialsProviderOnce() {
    clearTimeout(id);
    privateAccess.credentialProvider = currentCredentialProvider;
    return Promise.resolve(credentialsWithoutSessionToken);
  };
  privateAccess.credentialProvider = overrideCredentialsProviderOnce;
}